module.exports = __webpack_public_path__ + "media/images/report_areas/asic-312cf3833af716a89f7f60a5dc2781f4.png";